import isEqual from 'lodash/isEqual';

export default class ShouldCheckPrice {
  constructor(props, prevProps) {
    this.props = props;
    this.prevProps = prevProps;
    return this;
  }

  isErrorWhenPickUpAddress() {
    return this.props.departureAddress.error || this.props.returnAddress.error;
  }

  isDepartureGoogleAddressWithoutPostcodeAndStreet() {
    return this.isNoPostcodeAndStreet(this.props.departureAddress);
  }

  isReturnGoogleAddressWithoutPostcodeAndStreet() {
    return this.isNoPostcodeAndStreet(this.props.returnAddress);
  }

  isNoPostcodeAndStreet(addressObject) {
    var selectedObject = addressObject.selectedObject;
    return (selectedObject && selectedObject.g) &&
      (addressObject.postcode === null || addressObject.street === null);
  }

  isDifferentAddressChanged() {
    return this.props.differentReturnAddress !== this.prevProps.differentReturnAddress;
  }

  isDifferendAddressSelectedAndEmptyReturnAddress() {
    return this.props.differentReturnAddress && this.isReturnGoogleAddressWithoutPostcodeAndStreet();
  }

  selectedOptionsAreEmpty(){
    var returnAddressIsEmpty = false;
    if(this.props.differentReturnAddress){
      returnAddressIsEmpty = this.props.returnAddress.selectedObject === null;
    }
    return this.props.departureAddress.selectedObject === null || returnAddressIsEmpty;
  }

  areInputsChanged() {
    var departureSelectedChanged = !isEqual(this.props.departureAddress.selectedObject, this.prevProps.departureAddress.selectedObject);
    var returnSelectedChanged = !isEqual(this.props.returnAddress.selectedObject, this.prevProps.returnAddress.selectedObject);
    var departurePostcodeChanged = this.props.departureAddress.postcode !== this.prevProps.departureAddress.postcode;
    var returnPostcodeChanged = this.props.returnAddress.postcode !== this.prevProps.returnAddress.postcode;
    return departureSelectedChanged || returnSelectedChanged || departurePostcodeChanged || returnPostcodeChanged;
  }

  canRequestPrice = () => {
    if (this.isErrorWhenPickUpAddress() ||
      this.selectedOptionsAreEmpty() ||
      this.isDepartureGoogleAddressWithoutPostcodeAndStreet() ||
      this.isDifferendAddressSelectedAndEmptyReturnAddress()
    ) {
      return false;
    }
    return this.isDifferentAddressChanged() || this.areInputsChanged();
  }

}
